import React, { useState, useEffect } from "react";

const TableComponent = () => {
  const [isLargeScreen, setIsLargeScreen] = useState(() =>
      window.matchMedia("(min-width: 1280px)").matches
    );
      useEffect(() => {
        const mediaQuery = window.matchMedia("(min-width: 1280px)");
        const handleChange = (e) => setIsLargeScreen(e.matches);
        mediaQuery.addEventListener("change", handleChange);
    
        return () => {
          mediaQuery.removeEventListener("change", handleChange);
        };
      }, []);
  const rows = [
    { label: "Material", value: "Ti6Al4V" },
    { label: "Sizes", value: "9, 10, 11 mm diameter" },
    { label: "Bones", value: "Femur, Tibia" },
    { label: "Controller", value: "Wireless" },
    { label: "Supply", value: "12V" },
    { label: "Audio feedback", value: "Buzzer" },
    { label: "Weight Bearing", value: "Partial weight bearing" },
    { label: "Lengthening", value: "8 cm" },
  ];

  return (
    <>
  {isLargeScreen ? (
    <div className="d-flex justify-content-center upy-10 align-items-middle">
      <div
        className="uw-200 up-16 box-shadow bg-gray-light"
        style={{
          borderRadius: "calc(var(--unit) * 5)",
          overflow: "hidden",
        }}
      >
        <p className="m-0 upb-10 ufs-7 fw-bold text-center text-blue">
          Technical Specification
        </p>
        {rows.map((row, index) => (
          <div
            key={index}
            className="row m-0 up-2 uh-16 ufs-6 fw-bold bg-gray-light"
            style={{
              borderBottom: "calc(var(--unit) * 0.5) solid #ddd",
            }}
          >
            <div className="col text-start text-blue">{row.label}</div>
            <div className="col text-start text-gray">{row.value}</div>
          </div>
        ))}
      </div>
    </div>
  ) : (
    <div className="d-flex justify-content-center up-10 w-100 align-items-middle">
      <div
        className="w-100 up-16 box-shadow bg-gray-light"
        style={{
          borderRadius: "calc(var(--unit) * 5)",
          overflow: "hidden",
        }}
      >
        <p className="m-0 upb-10 ufs-14 fw-bold text-center text-blue">
          Technical Specification
        </p>
        {rows.map((row, index) => (
          <div
            key={index}
            className="row m-0 up-2  ufs-11 fw-bold bg-gray-light"
            style={{
              borderBottom: "calc(var(--unit) * 0.5) solid #ddd",
            }}
          >
            <div className="col text-start text-blue">{row.label}</div>
            <div className="col text-start text-gray">{row.value}</div>
          </div>
        ))}
      </div>
    </div>
  )}
</>

    
  );
};

export default TableComponent;
